export const checkUddsAvailability = async (reservationUrl) => {
    const url = new URL(reservationUrl, window.location.origin)
    const pathParts = url.pathname.split('/').filter(Boolean)
    const offerHash = decodeURIComponent(pathParts[pathParts.length - 1] || '')

    if (!offerHash) {
        throw new Error('Missing offer hash')
    }

    // Match the provider detection used by the reservation backend.
    const normalizedHash = offerHash.toUpperCase()

    if (
        normalizedHash.includes('|TUI') ||
        normalizedHash.includes('|R')
    ) {
        return true
    }

    const childrenAges = (url.searchParams.get('dzieci') || '')
        .split(',')
        .filter((age) => age.trim() !== '')
        .map(Number)

    const csrf = document.querySelector('meta[name="csrf-token"]')

    const response = await fetch('/api/travel/udds/availability', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': csrf ? csrf.content : '',
        },
        body: JSON.stringify({
            offerHash,
            operator: url.searchParams.get('operator'),
            adults: Number(url.searchParams.get('dorosli') || 2),
            childrenAges,
        }),
    })

    if (!response.ok) {
        throw new Error('Availability request failed')
    }

    const data = await response.json()

    if (typeof data.available !== 'boolean') {
        throw new Error('Invalid availability response')
    }

    return data.available
}
